import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import numeral from "numeral";

const borderColor = "#000000";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#cccccc",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
  },
  type: {
    width: "33.33%",
    textAlign: "left",
    paddingLeft: 8,
  },
  qty: {
    width: "33.33%",
    textAlign: "right",
    paddingRight: 8,
  },
  price: {
    width: "33.33%",
    textAlign: "right",
    paddingRight: 8,
  },
});

const InvoiceTableRow = ({ items }) => {
  const rows = items.map((item, idx) => {
    if (item.service === "Total") {
      return null;
    } else {
      return (
        <View
          style={[
            styles.row,
            {
              borderBottomWidth:
                item.quantity?.toString().includes("Grand Total") ||
                item.quantity?.toString().includes("Sisa Pembayaran") ||
                item.quantity?.toString().includes("Sudah Terbayarkan") ||
                item.quantity?.toString().includes("Subtotal") ||
                item.quantity?.toString().includes("VAT (1.1%)") ||
                item.quantity?.toString().includes("VAT (11%)") ||
                item.quantity?.toString().includes("Total") ||
                item.quantity?.toString().includes("PPH") ||
                item.quantity?.toString().includes("PPN")
                  ? 0
                  : 1,
              fontFamily:
                item.quantity?.toString().includes("Grand Total") ||
                item.quantity?.toString().includes("Total") ||
                item.quantity?.toString().includes("PPH") ||
                item.quantity?.toString().includes("PPN")
                  ? "HelveticaBold"
                  : "Helvetica",
            },
          ]}
          key={idx}
        >
          <Text style={styles.type}>{item.type}</Text>
          <Text style={styles.qty}>{item.quantity}</Text>
          <Text style={styles.price}>Rp. {numeral(item.price).format("0,0")}</Text>
        </View>
      );
    }
  });
  return <Fragment>{rows}</Fragment>;
};

export default InvoiceTableRow;
